export const startEventDiameter = 36;
